module.exports = __webpack_public_path__ + "static/media/logo-1.d5a6898a.png";